// ============================================================
// data.js - ALL TEXT CONTENT IS HERE
// ============================================================

export const NAV_LINKS = ["Home", "About us", "Our Services", "Galathiya Project"];

export const STATS = [
  { value: "15+", label: "Years of Experience" },
  { value: "500+", label: "Projects Completed" },
  { value: "1000+", label: "Workforce Deployed" },
  { value: "24/7", label: "Support Available" },
];

export const HIGHLIGHTS = [
  "Single-window local support partner",
  "Multi-service capability under one organization",
  "Island logistics & terrain expertise",
  "Safety, quality & compliance-driven operations",
  "Community-sensitive and responsible execution",
  "Experienced team with deep island knowledge",
];

export const HERO_BG = "/assets/hero5.webp";
export const GALATHIYA_BG = "https://images.unsplash.com/photo-1574044536246-fc3f4124230d?q=80&w=1000";

export const WHO_WE_SERVE = [
  { img: "/assets/serve_logistics.png" },
  { img: "/assets/serve_construction.png" },
  { img: "/assets/serve_engineering.png" },
  { img: "/assets/serve_workforce.png" },
  { img: "/assets/serve_equipment.png" },
  { img: "/assets/serve_truck.png" },
];

export const SERVICES = [
  {
    icon: "🚚",
    image: "/assets/serve_logistics.png",
    title: "Logistics & Project Support",
    desc: "Complete project logistics planning, material handling, and inter-island coordination.",
  },
  {
    icon: "⚙️",
    image: "/assets/serve_engineering.png",
    title: "Engineering Services",
    desc: "Civil, electrical, and mechanical works with professional execution.",
  },
  {
    icon: "🛡️",
    image: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?q=80&w=600",
    title: "Safety & Compliance",
    desc: "Industrial safety monitoring, fire protection systems, and regulatory compliance.",
  },
  {
    icon: "🔧",
    image: "/assets/serve_equipment.png",
    title: "Equipment Rentals",
    desc: "Generators, cranes, and specialized equipment with certified operators.",
  },
  {
    icon: "👷",
    image: "/assets/serve_workforce.png",
    title: "Manpower Solutions",
    desc: "Skilled, semi-skilled, and local workforce mobilization.",
  },
  {
    icon: "🏠",
    image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=600",
    title: "Real Estate Support",
    desc: "Residential and commercial properties for project teams.",
  },
];

export const FOOTER_QUICK_LINKS = ["Home", "About Us", "Our Services", "Galathiya Project", "Contact Us"];

export const FOOTER_SERVICES = [
  "Logistics & Project Support",
  "Engineering Services",
  "Safety & Compliance",
  "Equipment Rentals",
  "Manpower Solutions",
];

export const CONTACT_INFO = {
  address: "Prothrapur, Port Blair, South Andaman – 744 105",
  phones: ["9476051755", "9933207737", "03192-291945"],
  email: "Whaniportblair@gmail.com",
  whatsapp: "https://wa.me/919476051755",
};
